import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import AuthHeader from "./Header";
import AuthPrimary from "./Primary";
import XtSvg from "@/components/Xt/Svg";
interface LevelsProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const { getUrl } = Util;
const Levels: React.FC<LevelsProps> = ({ className }) => {
  const t = useTranslation();
  const { getAuthInfo, initialAuth, realAuth } = store.user;
  // useEffect
  useEffect(() => {
    getAuthInfo();
  }, []);
  return (
    <div className={cx(styles.account_auth, className)}>
      <div className={styles["auth_header"]}>
        <AuthHeader />
        <AuthPrimary />
        {/* {initialAuth == 2 && (
          <div className={styles["ll-auth-otc-div"]}>
            <XtSvg icon="otc-attestation-wait-ico" className={styles["ll-auth-otc-div-img"]} width={115} height={75} color="#45BF76" />
            <a className={styles["ll-auth-otc-div-desc"]}>{t("account.UnderReview")}</a>
            <a className={styles["ll-auth-otc-div-buy"]} href={getUrl("/otc")}>
              {t("account.GoBuyCoins")}
            </a>
          </div>
        )} */}
        {initialAuth == 2 && (
          <div className={styles["ll-auth-otc-div"]}>
            <XtSvg className={styles["ll-auth-otc-div-img"]} src={require("@/assets/icon-svg/account/otc_attestation_adopt_ico.svg")} width={115} height={75} />
            <p className={styles["ll-auth-otc-div-desc"]}>{t("account.CompletedrealNameAuthentication")}</p>
            <a className={styles["ll-auth-otc-div-buy"]} href={getUrl("/otc")}>
              {t("account.GoBuyCoins")} &gt;
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
export default observer(Levels);
